import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import throttle from 'lodash-es/throttle';

import { pinkishOrange, progressBarZIndex } from '~/styles';

interface Props {
  contentId: string;
  style?: React.CSSProperties;
}

const ProgressBar = styled.progress<{ visible?: boolean }>`
  height: 3px;
  width: 100%;
  position: fixed;
  top: 50px;
  left: 0;
  z-index: ${progressBarZIndex};
  appearance: none;
  border: none;
  background: none;
  opacity: 0;
  transition: opacity 250ms ease-in-out;
  ::-webkit-progress-value {
    transition: width 250ms ease-out;
  }
  ${props =>
    props.visible &&
    css`
      opacity: 1;
    `} &::-webkit-progress-bar {
    background-color: transparent;
  }

  &::-webkit-progress-value {
    background-color: ${pinkishOrange};
  }

  &::-moz-progress-bar {
    background-color: ${pinkishOrange};
  }

  &[value] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: ${pinkishOrange};
    background-color: none;
  }

  &[value]::-webkit-progress-bar {
    background-color: none;
  }

  &::-webkit-progress-value {
    background-color: ${pinkishOrange};
  }

  &::-moz-progress-bar {
    background: ${pinkishOrange};
  }

  &::-ms-fill {
    border: none;
  }
`;

export class Progress extends React.Component<Props> {
  progressRef: React.RefObject<HTMLProgressElement> = React.createRef();
  scrolled = 0;
  updateScrollProgressThrottled = throttle(() => {
    const content = document.getElementById('content');
    if (!content || !this.progressRef.current) return;
    const winScroll = document.documentElement
      ? document.documentElement.scrollTop
      : document.body.scrollTop;
    const contentHeight = content.scrollHeight;
    const contentOffsetTop = content.offsetTop;

    const scrolled = ((winScroll - contentOffsetTop) / (contentHeight - contentOffsetTop)) * 100;
    this.progressRef.current.value = scrolled;
    this.progressRef.current.style.opacity = scrolled <= 115 ? '1' : '0';
  }, 50);

  componentDidMount() {
    window.addEventListener('scroll', this.updateScrollProgressThrottled);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.updateScrollProgressThrottled);
  }

  render() {
    const { style, contentId } = this.props;

    return (
      <ProgressBar
        ref={this.progressRef}
        max={100}
        style={style}
        data-target={`learn-article-${contentId}`}
      />
    );
  }
}
